import { ConfirmModal } from '@sparklayer-io/spark-dash-ui/components/confirm-modal';
import { Text } from '@ui/themed';
import { t } from 'i18next';
import { useEffect, useState } from 'react';
import { ApiResponseError } from '../../../types/errors';
import { useDeleteTheme } from '../hooks/use-themes';
import type { Theme } from '../types/theme';

export function DeleteThemeModal({ theme, onClose }: { theme: Theme | null; onClose: () => void }) {
  const deleteTheme = useDeleteTheme();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (theme) {
      setError(null);
    }
  }, [theme]);

  async function handleDelete() {
    if (!theme) {
      return;
    }
    setError(null);
    try {
      await deleteTheme.mutateAsync(theme.id);
      onClose();
    } catch (err) {
      if (err instanceof ApiResponseError && err.status === 404) {
        setError(
          t('features:themes.pages.themes_list_page.modals.delete.not_found', { name: theme.name }),
        );
        return;
      }
      setError(
        t('features:themes.pages.themes_list_page.modals.delete.failed', { name: theme.name }),
      );
    }
  }

  return (
    <ConfirmModal
      isOpen={theme !== null}
      onClose={onClose}
      onConfirm={() => void handleDelete()}
      loading={deleteTheme.isPending}
      title={t('features:themes.pages.themes_list_page.modals.delete.title')}
      confirmText={t('buttons:delete')}
      message={t('features:themes.pages.themes_list_page.modals.delete.message', {
        name: theme?.name ?? '',
      })}
    >
      {error && <Text variant="secondary">{error}</Text>}
    </ConfirmModal>
  );
}
